export class UserLogin {
    SessionId: string;
    DeviceId: string;
    DeviceVerificationId: string;
    Password: string;
}

export enum LoginPasswordType {
    PAS = 0,
	BIO = 1,
	PIN = 2,
	SSO = 3
}


// WEBPACK FOOTER //
// ./src/model/models/register/user-register.ts